// extracted by mini-css-extract-plugin
export default {"main":"BaseSimpleItemBrowserHeader_main__n3uNP","tip":"BaseSimpleItemBrowserHeader_tip__DnD7q"};